// for a better seo and having a unique title for each page we had to install Helmet Package
import React from 'react';
import { Helmet } from 'react-helmet-async';
export default function HelmetComponent({ title, description }) {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name='description' content={`فایلینگ پلاک من- ${description}`} />
        </Helmet>
    )
}